module.exports = function() {
    this._sendMessage('startDnd');
};